(() => {
  'use strict';
  const script = document.currentScript;
  if (!script || window.pooltimeMarketingWebLoaded) return;
  window.pooltimeMarketingWebLoaded = true;
  const market = script.dataset.market === 'GB' ? 'UK' : script.dataset.market;
  const hosts = { SE: 'pooltime.se', DK: 'pooltime.dk', NO: 'pooltime.no', FI: 'pooltime.fi', DE: 'pooltime.de', UK: 'pooltime.co.uk' };
  if (!hosts[market] || ![hosts[market], 'www.' + hosts[market]].includes(location.hostname)) return;
  const endpoint = 'https://backup.pooltime.se/marketing-web/collect.php';
  const key = 'pooltime-marketing-web-' + market;
  const fetchNative = window.fetch.bind(window);
  let identity = '', session = null, pending = null, generation = 0, cartHash = '', timer = null, lastPermission = null;
  try {
    const u = new URL(location.href), fragment = new URLSearchParams(u.hash.slice(1));
    identity = fragment.get('ptm_id') || '';
    if (identity) { fragment.delete('ptm_id'); u.hash = fragment.toString(); history.replaceState(history.state, '', u.pathname + u.search + u.hash); }
  } catch (_) { return; }
  const allowed = () => typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function' && window.Shopify.customerPrivacy.marketingAllowed() === true;
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const write = value => { try { if (value) localStorage.setItem(key, JSON.stringify(value)); else localStorage.removeItem(key); } catch (_) {} };
  const post = async (payload, force = false) => {
    if (!force && !allowed()) throw new Error('consent_required');
    const response = await fetchNative(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', redirect: 'error', referrerPolicy: 'no-referrer', headers: { 'Content-Type': 'application/json', 'X-Pooltime-Web': '1' }, body: JSON.stringify({ market, ...payload }) });
    if (!response.ok) throw new Error('tracking_unavailable');
    return response.json();
  };
  async function start() {
    if (!allowed()) return null;
    if (session && Date.parse(session.expires_at) > Date.now()) return session;
    if (pending) return pending;
    const epoch = generation, previous = read();
    pending = post({ op: 'session', consent: { marketing: true }, token: previous?.token || '', identity: identity || previous?.identity || '' }).then(next => {
      if (!allowed() || epoch !== generation) { post({ op: 'revoke', token: next.token }, true).catch(() => {}); return null; }
      session = next; write({ token: next.token, expires_at: next.expires_at, identity: identity || previous?.identity || '' }); return next;
    }).catch(error => { identity = ''; write(null); throw error; }).finally(() => { pending = null; });
    return pending;
  }
  async function emit(type, payload = {}) {
    if (!allowed()) return;
    const epoch = generation, s = await start();
    if (!s || epoch !== generation || !allowed()) return;
    await post({ op: 'event', token: s.token, consent: { marketing: true }, type, event_id: crypto.randomUUID(), ...payload }); return true;
  }
  async function cart() {
    if (!allowed() || document.visibilityState === 'hidden') return;
    const epoch = generation, root = (window.Shopify?.routes?.root || script.dataset.root || '/').replace(/\/?$/, '/');
    const response = await fetchNative(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok || !allowed() || epoch !== generation) return;
    const c = await response.json();
    if (!Array.isArray(c.items) || c.items.length > 100 || !allowed()) return;
    const payload = { currency: c.currency, root, items: c.items.map(item => ({ product_id: String(item.product_id), quantity: item.quantity, final_line_price: item.final_line_price })) };
    const fingerprint = JSON.stringify(payload);
    if (fingerprint === cartHash) return;
    const sent = await emit('cart_updated', payload); if (sent && allowed() && epoch === generation) cartHash = fingerprint;
  }
  async function consentChanged() {
    const permission = allowed(); if (permission === lastPermission) return; const previousPermission = lastPermission; lastPermission = permission;
    generation++;
    if (!allowed()) {
      const old = session || read(); session = null; if (previousPermission === true) identity = ''; cartHash = ''; clearInterval(timer); timer = null; write(null);
      if (old?.token) post({ op: 'revoke', token: old.token }, true).catch(() => {});
      return;
    }
    try {
      await emit('site_active');
      if (script.dataset.product) await emit('product_viewed', { product_id: script.dataset.product });
      await cart();
      if (!timer) timer = setInterval(() => cart().catch(() => {}), 30000);
    } catch (_) {}
  }
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('visibilitychange', () => { if (allowed() && document.visibilityState === 'visible') cart().catch(() => {}); });
  document.addEventListener('submit', event => { if (event.target?.matches?.('form[action*="/cart"]') && allowed()) setTimeout(() => cart().catch(() => {}), 1500); });
  if (window.Shopify?.customerPrivacy) consentChanged();
  else if (typeof window.Shopify?.loadFeatures === 'function') window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) consentChanged(); });
})();
